export const bytesToGB = (bytes, appendUnit = false) => {
  const formatted = Math.floor(bytes / 1000000000);
  return appendUnit ? `${formatted} GB` : formatted;
};

export const bytesToGiB = (bytes, appendUnit = false) => {
  const formatted = bytes / 1073741824;
  return appendUnit ? `${formatted} GB` : formatted;
};

export const bytesToMB = (bytes, appendUnit = false) => {
  const formatted = Math.floor(bytes / 1000000);
  return appendUnit ? `${formatted} MB` : formatted;
};

export const bytesToKB = (bytes, appendUnit = false) => {
  const formatted = Math.ceil(bytes / 1000);
  return appendUnit ? `${formatted} KB` : formatted;
};

export const bytesToB = (bytes) => {
  return `${bytes} B`;
};

export const bytesToHuman = (bytes) => {
  if (bytes < 1000) return bytesToB(bytes);
  if (bytes < 1000000) return bytesToKB(bytes, true);
  if (bytes < 1000000000) return bytesToMB(bytes, true);
  if (bytes >= 1000000000) return bytesToGB(bytes, true);
};

export const calcPercentageAndRound = (used, avail) => Math.round((parseInt(used) * 100) / parseInt(avail));
